import { createElement } from 'react';
import { Page } from './';
import { Footer } from './';
import withStyles, { WithStyles } from 'react-jss';
import { observer } from 'mobx-react';
import flowRight from 'lodash.flowright';
import { store } from '../store';
import { ComponentDesc } from '../store';
import { DropTargetConnector } from 'react-dnd';
import { DropTarget } from 'react-dnd';
import { DropTargetMonitor } from 'react-dnd';
import { ItemTypes } from '../Constants';
import AddRowComponent from '../components/addRowDiv';

const styles = {
    workSection: {
        flexGrow: 1,
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
    },

    workArea: {
        flexGrow: 1,
        justifyContent: 'center',
    },
};

interface IProps extends WithStyles<typeof styles> {
    connectDropTarget: any;
}

const component: React.FunctionComponent<IProps> = ({ connectDropTarget, incoming, classes, isOver }) => {
    if (!isOver) {
        if (store.tempCard) {
            console.log('onMouseOut');

            setTimeout(function() {
                removeCard(store.tempCard.id);
                store.tempCard = null;
            }, 200);
        }
    }
    return connectDropTarget(
        <div className={classes.workSection}>
            <div className={classes.workArea + ' work-area'} style={{ opacity: incoming ? 0.2 : 1, background: incoming ? '#fff3b5' : 'white', border: incoming ? '1px dashed #d6923e' : 'none', overflow: 'auto', paddingBottom: '10px', paddingTop: '10px' }} onClick={(e) => store.selectComponent(null)}>
                <Page />
                <AddRowComponent type="column" targetArray={store.currentTemplate.rows} targetIndex={store.currentTemplate.rows.length} />
            </div>

            <Footer />
        </div>
    );
};

let removeCard = (id) => {
    const { card, index } = findCard(id);
    if (card) {
        store.currentTemplate.rows.splice(index, 1);
    }
};

let findCard = (id) => {
    const cards = store.currentTemplate.rows;
    const card = cards.filter((c) => c.id === id)[0];

    return {
        card,
        index: cards.indexOf(card),
    };
};

export default flowRight([
    withStyles(styles),
    DropTarget(
        ItemTypes.COLUMN_WRAPPER,
        {
            drop(props: ComponentDesc<any>, monitor: DropTargetMonitor, component: any) {
                console.log('WorkArea: DROP: ', monitor.didDrop());
                if (!monitor.didDrop()) {
                    let item = monitor.getItem();
                    if (!item.id) {
                        item.id = +new Date();
                    }
                    if (!store.currentTemplate.rows.some((r) => r.id === item.id)) {
                        store.currentTemplate.rows.push(item);
                    }
                }
                store.tempCard = null;
                return { handled: true };
            },
            hover() {},
        },
        (connect: DropTargetConnector, monitor: DropTargetMonitor) => {
            return {
                connectDropTarget: connect.dropTarget(),
                incoming: monitor.isOver({ shallow: true }),
                isOver: monitor.isOver({ shallow: false }),
            };
        }
    ),
    observer,
])(component);
